import { render, staticRenderFns } from "./xhs_table.vue?vue&type=template&id=b5e3718c"
import script from "./xhs_table.vue?vue&type=script&lang=js"
export * from "./xhs_table.vue?vue&type=script&lang=js"
import style0 from "./xhs_table.vue?vue&type=style&index=0&id=b5e3718c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports